import * as Sentry from "@sentry/vue";
import store from "@/store";
import type { AxiosError } from "axios";

/**
 * 센트리 예외처리 오류를 발생시킵니다.
 * sentryTracing에 잡힌 경우 해당 기능은 동작하지 않습니다.
 * 개발망, 상용망에서만 사용합니다.
 */
export function sentryException(msg: string, err: object | string) {
  if (import.meta.env.VITE_ENV === "local") return;
  const scope = new Sentry.Scope();
  scope.setExtra("ErrorResponse", err);
  scope.setExtra("User", {
    name: store.getters["auth/getClientInfo"]().name,
    center: store.getters["auth/getCenterInfo"]().name,
    staff: store.getters["auth/getCenterInfo"]().staff ? "유인" : "무인",
    token: store.getters["auth/getSessionToken"](),
  });
  Sentry.captureException(new Error(msg), () => scope);
}
export class SentryApiException {
  private IS_LOCAL = import.meta.env.VITE_ENV === "local";

  /** Exception 유저 정보 */
  private getUserInfomation() {
    return {
      name: store.getters["auth/getClientInfo"]().name,
      center: store.getters["auth/getCenterInfo"]().name,
      staff: store.getters["auth/getCenterInfo"]().staff ? "유인" : "무인",
    };
  }

  withReponse(error: AxiosError) {
    if (this.IS_LOCAL) return;
    const { method, url, params, data: requestData, headers } = error.config;
    const { data: responseData, status } = error.response!;

    Sentry.withScope((scope) => {
      scope.setLevel(Sentry.Severity.Error);
      scope.setTag("API_STATUS", "response");
      scope.setTag("API", status);

      scope.setContext("User", this.getUserInfomation());
      Sentry.setContext("요청상세", {
        method,
        url,
        params,
        headers,
        data: requestData,
        message: error.message,
      });
      Sentry.setContext("응답상세", {
        status,
        data: responseData,
        errMsg: responseData.errorMsg.toString(),
      });
      Sentry.captureMessage(`[API_${status}] ${url}`); // Message title
    });
  }
  withoutResponse(error: AxiosError, location: string) {
    if (this.IS_LOCAL) return;
    const { method, url, params, data: requestData, headers } = error.config;

    Sentry.withScope((scope) => {
      scope.setLevel(Sentry.Severity.Info);
      scope.setTag("API_STATUS", "noneResponse");

      scope.setContext("User", this.getUserInfomation());
      Sentry.setContext("요청상세", {
        method,
        url,
        params,
        headers,
        data: requestData,
        message: error.message,
      });
      Sentry.setContext("추가정보", {
        location,
        ...error.toJSON(),
      });
      Sentry.captureMessage(`[API_NoneResponse] ${url}`); // Message title
    });
  }
}
